import React, { useState } from 'react';
import styled from 'styled-components';
import { Fade as Hamburger } from 'hamburger-react';
import { themeGet } from '@styled-system/theme-get';
import useDropdown from '../../../lib/hooks/useDropdown';
import { useBoards } from '../data';
import RegisteredUserOptions from './RegisteredUserOptions.jsx';
import BoardsArea from './BoardsArea.jsx';
import GuestOptions from './GuestOptions.jsx';

const HamburgerContainer = styled.div`
  cursor: pointer;
  margin-left: 5px;
  margin-right: -11px;

  ${themeGet('mediaQueries.forMediumUp')} {
    display: none;
  }
`;

const List = styled.ul`
  position: absolute;
  top: 38px;
  right: 0;
  border-radius: 8px;
  background: white;
  z-index: 3;
  width: 200px;
  font-weight: 500;
  font-size: 14px;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  max-height: 80vh;
  overflow-y: auto;

  ${themeGet('mediaQueries.forMediumUp')} {
    top: 51px;
  }
`;

export default function MobileMenu({ userType, guestUserResetPath }) {
  const {
    dropdownRef,
    buttonRef,
    showDropdown,
    setShowDropdown,
  } = useDropdown();
  const { boards, isLoading, isIdle, fetchBoards } = useBoards();

  const [dropdownContent, setDropdownContent] = useState('menuList');

  const onSwitchBoardsClick = () => {
    if (isIdle) {
      fetchBoards();
    }
    setDropdownContent('boardsArea');
  };

  const dropdownContents = {
    boardsArea: <BoardsArea isLoading={isLoading} boards={boards} />,
    menuList: (
      <List ref={dropdownRef}>
        {userType === 'guest' ? (
          <GuestOptions guestUserResetPath={guestUserResetPath} />
        ) : (
          <RegisteredUserOptions
            onSwitchBoardsClick={onSwitchBoardsClick}
            userType={userType}
          />
        )}
      </List>
    ),
  };

  return (
    <div style={{ position: 'relative' }}>
      <HamburgerContainer
        ref={buttonRef}
        onClick={() => {
          setShowDropdown(state => !state);
          setDropdownContent('menuList');
        }}
        dropdownOpen={showDropdown}
      >
        <Hamburger color="#52575C" rounded size={20} />
      </HamburgerContainer>
      {showDropdown && dropdownContents[dropdownContent]}
    </div>
  );
}
